export default function getUrlParameter(parameter: string): string | undefined {
  // eslint-disable-next-line
  const parameterName = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + parameterName + '=([^&#]*)')
  var results = regex.exec(window.location.search)
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '))
}
